import React from 'react';
import WaitingCall from "../../../../../assets/images/mobileLab/waiting_for_call.svg"
import WaitingPrice from "../../../../../assets/images/mobileLab/waiting_for_price.svg"
import WaitingSample from "../../../../../assets/images/mobileLab/waiting_for_sampling.svg"
import WaitingResult from "../../../../../assets/images/mobileLab/waiting_for_result.svg"
import WaitingPayment from "../../../../../assets/images/mobileLab/waiting_for_payment.svg"

const TileItemMobile = (props) => {
    const {tile, active} = props;
    const renderImgaeForTile = () => {
        switch (tile.name) {
            case "waiting_for_call" :
                return <img src={WaitingCall} />
            case "waiting_for_price" :
                return <img src={WaitingPrice} />
            case "waiting_for_sampling" :
                return <img src={WaitingSample} />
            case "waiting_for_result" :
                return <img src={WaitingResult} />
            case "waiting_for_payment" :
                return <img src={WaitingPayment} />
        }
    }
    return(
        <div className={active ? "tile-item-active-mobile" : "tile-item-mobile shadow-sm"} onClick={props.onClick}>
            <div className="tile-icon-mobile">
                {renderImgaeForTile()}
            </div>
            <div className="tile-title-mobile">
                {tile.title}
            </div>
            <div className="tile-count-mobile">
                {tile.count}
            </div>
        </div>
    )
}

export default TileItemMobile;